import { render, staticRenderFns } from "./sendCar.vue?vue&type=template&id=08028efb&scoped=true&"
import script from "./sendCar.vue?vue&type=script&lang=js&"
export * from "./sendCar.vue?vue&type=script&lang=js&"
import style0 from "./sendCar.vue?vue&type=style&index=0&id=08028efb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08028efb",
  null
  
)

export default component.exports